import { Deals } from '../../pages/deals/index/deals.page';
import routes from '../routes/index.routes';

export const DealsRouter = [
	{
		path: routes.deals.index(),
		element: <Deals />,
	},
];
